import React from "react";
import styles from '../PopUp/Popup.module.css';
import { FaCheck, FaTimes } from "react-icons/fa";


export const ThanksMessage = ({ setShowPopup, buttonClose }) => {
  return (
    <div className={styles.confirmationSendNumber}>
      {
        buttonClose &&
        <div className={styles.closeButton} onClick={() => setShowPopup(false)}>
            <FaTimes />
        </div>
      }
      <div className={styles.checkSendIcon}>
        <FaCheck color="white" size={30} />
      </div>
      <h2 className={styles.messageThanks}>
        Gracias por ser parte de nuestra comunidad
      </h2>
      <p className={styles.messageNotification}>
        Muy pronto recibirás noticias
      </p>
    </div>
  );
};
